import React from "react";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

interface SemiCircleRoundedProps extends SvgIconProps {
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

const SemiCircleRounded: React.FC<SemiCircleRoundedProps> = props => {
  const theme = useTheme();
  return (
    <SvgIcon width="49" height="42" viewBox="0 0 49 42" {...props} sx={{ ...props.sx, color: "transparent" }}>
      <path
        d="M9.60065 33.6002C5.00065 24.9002 8.30065 14.2002 17.0006 9.60016C25.7006 5.00016 36.4006 8.30016 41.0006 17.0002"
        stroke={props?.color ? theme.palette[props.color].light : props?.htmlColor}
        strokeWidth="15"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default SemiCircleRounded;
